module.exports = __webpack_public_path__ + "img/bDate.8016a2d7.svg";